var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"type":"text","inputmode":"numeric"},domProps:{"value":_vm.displayValue},on:{"input":_vm.onInput,"blur":_vm.onBlur,"focus":_vm.onFocus,"keydown":_vm.onKeyDown,"focusin":function($event){return _vm.$emit('focusin')},"focusout":function($event){return _vm.$emit('focusout')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }